<template>
  <v-card class="elevation-0">
    <v-card-title>
      {{ title }}
      <v-spacer></v-spacer>

      <v-text-field
        v-on:keyup.enter="searchOnEnter"
        v-on:blur="searchOnEnter"
        append-icon="mdi-magnify"
        hint="Kode, Deskripsi (press ENTER to search)"
        label="Search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-model="selectedItems"
      :single-select="!multiSelect"
      :show-select="multiSelect"
      :headers="headers"
      :items="fInfoPasarsFiltered"
      :page.sync="currentPage"
      :items-per-page="pageSize"
      hide-default-footer
      class="elevation-0"
      @page-count="totalTablePages = totalPaginationPages"
    >
      <template v-slot:top>
        <v-row align="center" class="ml-4 mr-4">
          <v-switch
            v-model="multiSelect"
            :label="multiSelect ? 'Multi Select' : 'Single Select'"
            x-small
            class="pa-3"
          ></v-switch>
          <v-btn
            fab
            dark
            color="red accent-4"
            x-small
            :disabled="!multiSelect"
            class="mr-2"
            @click="deleteDialogMultiShow"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            fab
            dark
            color="green"
            x-small
            @click="showDialogNew"
            :disabled="multiSelect || fromPublic"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </template>

      <template v-slot:[`item.statusActive`]="{ item }">
        <v-chip :color="getColorStatusActive(item.statusActive)" dark small>
          {{ item.statusActive == true ? "Aktif" : "-" }}
        </v-chip>
      </template>

      <template v-slot:[`item.fvendorBean`]="{ item }">
        <div>
          {{ lookupFVendor(item.fvendorBean).vname }}
        </div>
      </template>
      <template v-slot:[`item.fmaterialBean`]="{ item }">
        <div>
          {{ lookupFMaterial(item.fmaterialBean).pname }}
        </div>
      </template>

      <template v-slot:[`item.fvendorBean`]="{ item }">
        <div>
          {{ lookupFVendor(item.fvendorBean).vname }}
        </div>
        <div class="caption">
          {{ lookupFVendor(item.fvendorBean).district1 }}
        </div>

        <div v-if="lookupFVendor(item.fvendorBean).lon > 0">
          <v-btn
            @click="openGoogleMap(lookupFVendor(item.fvendorBean))"
            x-small
            outlined
            rounded
          >
            <v-icon small>mdi-map-marker</v-icon>
            {{ lookupFVendor(item.fvendorBean).lat }},{{
              lookupFVendor(item.fvendorBean).lon
            }}
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.price`]="{ item }">
        <div>Rp. {{ formattedCurrencyValue("", item.price) }}</div>
        <div class="grey--text">
          per {{ lookupFMaterial(item.fmaterialBean).uom4 }}
        </div>
      </template>

      <template v-slot:[`item.fdivisionBean`]="{ item }">
        <div class="fill-height">
          <div class="text-caption small">
            {{ lookupFDivision(item.fdivisionBean) }}
          </div>
        </div>
      </template>

      <template
        v-slot:[`item.actions`]="{ item }"
        v-if="fromPublic === 'false'"
      >
        <v-btn @click="showDialogEdit(item)" icon :disabled="multiSelect">
          <v-icon small color="warning"> mdi-pencil </v-icon>
        </v-btn>

        <v-btn @click="deleteDialogShow(item)" icon :disabled="multiSelect">
          <v-icon small color="red accent-4"> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-container>
      <v-row justify="end" align="center">
        <v-col cols="4" md="2" sm="2">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Items per page"
          ></v-select>
        </v-col>
        <v-col cols="10" md="9" sm="8" align="right">
          <v-pagination
            v-model="currentPage"
            :length="totalPaginationPages"
            total-visible="8"
            circle
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>

    <DeleteConfirmDialog
      ref="refDeleteConfirmDialog"
      @eventFromDeleteConfirmDialog1="deleteItemConfirmedSingleSelect"
      @eventFromDeleteConfirmDialog2="deleteItemConfirmedMultiSelect"
    ></DeleteConfirmDialog>

    <FInfoPasarDialog
      ref="refFormDialog"
      :formMode.sync="formMode"
      :itemsFVendor="itemsFVendor"
      :itemsFMaterial="itemsFMaterial"
      @eventFromFormDialogNew="saveDataNew"
      @eventFromFormDialogEdit="saveDataEdit"
    ></FInfoPasarDialog>

    <v-snackbar v-model="snackbar">
      {{ snackBarMesage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import FInfoPasarService from "../../../services/apiservices/f-info-pasar-service";
import FDivisionService from "../../../services/apiservices/f-division-service";

import DeleteConfirmDialog from "../../utils/DeleteConfirmDialog";

import FInfoPasarDialog from "./FInfoPasarDialog";
import FormMode from "../../../models/form-mode";
import FInfoPasar from "../../../models/f-info-pasar";
import FileService from "../../../services/apiservices/file-service";
import FMaterialService from "@/services/apiservices/f-material-service";
import FVendorService from "@/services/apiservices/f-vendor-service";

export default {
  components: { FInfoPasarDialog, DeleteConfirmDialog },
  props: {
    fromPublic: Boolean,
  },
  data() {
    return {
      title: "INFO PASAR",
      snackbar: false,
      snackBarMesage: "",

      multiSelect: false,
      selectedItems: [],

      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 10,
      pageSizes: [10, 25, 50, 150, 500],

      search: "",
      headers: [
        // { text: 'Description', value: 'description', width:"30%" },
        { text: "Material", value: "fmaterialBean" },
        // { text: 'Satuan', value: 'satuan' },
        { text: "Harga", value: "price" },
        { text: "Pemasok", value: "fvendorBean" },
        { text: "Author", value: "fdivisionBean" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      formMode: "",
      itemSelectedIndex: -1,
      itemSelected: "",
      fInfoPasars: [new FInfoPasar(0, "", "")],
      itemsFDivision: [{ id: 0, kode1: "", description: "" }],
      itemsFVendor: [],
      itemsFMaterial: [],
    };
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (value) this.fetchFInfoPasar();
      },
    },
    pageSize: {
      handler: function (value) {
        const refreshData = this.currentPage == 1;
        this.currentPage = 1;
        if (refreshData) {
          console.log("Change PageSize " + value);
          this.fetchFInfoPasar();
        }
        // console.log("page size = " + value + " >> " + this.totalPages)
      },
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    fInfoPasarsFiltered() {
      return this.fInfoPasars;
    },
  },
  methods: {
    searchOnEnter(event) {
      if (this.search !== event.target.value) {
        //Krusial untuk search
        // console.log(`${event.target.value} vs ${this.search}`)
        this.currentPage = 1;
        this.search = event.target.value;
        this.fetchFInfoPasar();
      }
    },
    fetchParent() {
      try {
        if (this.currentUser.organizationLevel === "DIV") {
          FDivisionService.getFDivisionById(
            this.currentUser.fdivisionBean
          ).then(
            (response) => {
              this.itemsFDivision = [response.data];
              // console.log(response.data.items)
            },
            (error) => {
              console.log(error.response);
            }
          );
        } else {
          FDivisionService.getAllFDivision().then(
            (response) => {
              // console.log(JSON.stringify(response.data))
              this.itemsFDivision = response.data;
            },
            (error) => {
              console.log(error.response);
            }
          );
        }
      } catch (e) {
        e.toString();
      }

      FMaterialService.getAllFMaterial().then(
        (response) => {
          this.itemsFMaterial = response.data;
        },
        (error) => {
          console.log(error);
        }
      );
      FVendorService.getAllFVendor().then(
        (response) => {
          this.itemsFVendor = response.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    fetchFInfoPasar() {
      FInfoPasarService.getAllFInfoPasarContaining(
        this.currentPage,
        this.pageSize,
        "id",
        "DESC",
        this.search
      ).then(
        (response) => {
          // console.log(response.data.items)
          const { items, totalPages } = response.data;
          this.fInfoPasars = items;
          this.totalPaginationPages = totalPages;
          // console.log(`TotalPage ${totalPages} and TotalItems ${items} `)
        },
        (error) => {
          console.log(error.response);
          if (error.response.status === 401) {
            this.snackBarMesage = "Anda tidak mempunyai Akses!!";
            this.snackbar = true;
          }
        }
      );
    },
    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },

    showDialogNew() {
      this.itemSelectedIndex = -1;
      const itemModified = Object.assign({}, "");
      // this.formDialogShow = true
      this.formMode = FormMode.NEW_FORM;
      this.$refs.refFormDialog.showDialog(
        this.itemSelectedIndex,
        itemModified,
        this.itemsFDivision
      );
    },
    saveDataNew(itemFromRest) {
      this.itemSelected = itemFromRest;
      this.closeDialog();
      /**
       * Setiap data baru harus terlihat
       */
      // this.fInfoPasars.push(this.itemSelected)
      // this.fInfoPasars = [itemFromRest].concat(this.fInfoPasars)
      // this.fInfoPasars.unshift(itemFromRest)
      this.fetchFInfoPasar();
    },

    showDialogEdit(item) {
      this.itemSelectedIndex = this.fInfoPasarsFiltered.indexOf(item);
      const itemModified = Object.assign({}, item);
      // this.formDialogShow = true
      this.formMode = FormMode.EDIT_FORM;
      this.$refs.refFormDialog.showDialog(
        this.itemSelectedIndex,
        itemModified,
        this.itemsFDivision
      );
    },
    saveDataEdit(item) {
      this.itemSelected = item;
      try {
        Object.assign(
          this.fInfoPasars[this.itemSelectedIndex],
          this.itemSelected
        );
      } catch (e) {
        this.fetchFInfoPasar();
        e.toString();
      }
      this.closeDialog();
    },

    deleteDialogShow(item) {
      // console.log(item)
      this.itemSelectedIndex = this.fInfoPasarsFiltered.indexOf(item);
      this.itemSelected = Object.assign({}, item);
      // this.myConfirmDelete = true
      this.$refs.refDeleteConfirmDialog.showDialog(
        this.itemSelectedIndex,
        item.username
      );
    },
    deleteDialogMultiShow() {
      if (this.multiSelect === true) {
        // console.log(`nilai ${this.selectedItems}`)
        this.$refs.refDeleteConfirmDialog.showDialogMulti(
          this.selectedItems,
          `${this.selectedItems.length} items selected`
        );
      }
    },
    deleteItemConfirmedSingleSelect(index) {
      console.log("delete SingleItem: " + index);

      const deletedItem = this.fInfoPasars[this.itemSelectedIndex];
      FInfoPasarService.deleteFInfoPasar(deletedItem.id).then(
        () => {
          // console.log("hapus bos " + response.data + " >> " + this.itemSelectedIndex)
          this.fInfoPasars.splice(this.itemSelectedIndex, 1);
          this.closeDialog();
        },
        (error) => {
          console.log(error);
          this.snackBarMesage = "gagal hapus (digunakan oleh data anakk)";
          this.snackbar = true;
          this.$refs.refDeleteConfirmDialog.setDialogState(false);
        }
      );
    },
    deleteItemConfirmedMultiSelect(items) {
      // console.log(okeMessage)
      if (items.length > -1) {
        let itemIds = [];
        for (let i = 0; i < items.length; i++) {
          itemIds.push(items[i].id);
        }
        // console.log("Item idex: " + itemIds)

        FInfoPasarService.deleteAllFInfoPasar(itemIds).then(
          (response) => {
            if (response.data) {
              for (let i = 0; i < items.length; i++) {
                if (
                  !response.data.includes(items[i].id) ||
                  response.data.length === 0
                ) {
                  const index = this.fInfoPasarsFiltered.indexOf(items[i]);
                  this.fInfoPasars.splice(index, 1);
                }
                if (response.data.length > 0) {
                  this.snackBarMesage = `${response.data.length} items gagal hapus (digunakan oleh data anak)`;
                  this.snackbar = true;
                }

                // console.log("Undeleted Items: " + response.data + " = " + items[i].id)
              }
              this.closeDialog();
            }
          },
          (error) => {
            console.log("error " + error);
          }
        );

        // console.log(items)
        // FInfoPasarService.deleteAllFInfoPasars()
      }
    },
    closeDialog() {
      // this.myConfirmDialog = false
      this.formMode = "";
      this.$refs.refDeleteConfirmDialog.setDialogState(false);
      this.$refs.refFormDialog.setDialogState(false);

      this.$nextTick(() => {
        this.itemSelected = Object.assign({}, new FInfoPasar());
        this.itemSelectedIndex = -1;
      });
    },

    getColorStatusActive(trueFalse) {
      if (trueFalse === true) return "green";
      else if (trueFalse === false) return "gray";
      else return "gray";
    },

    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id === fdivisionBean);
      if (str.length > 0) {
        return str[0].description;
      } else {
        return "-";
      }
    },
    lookupFVendor(fvendorBean) {
      const str = this.itemsFVendor.filter((x) => x.id === fvendorBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFMaterial(fmaterialBean) {
      const str = this.itemsFMaterial.filter((x) => x.id === fmaterialBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    formattedCurrencyValue(prefix, value) {
      if (!value) {
        return "0";
      }
      // return "Rp." + parseFloat(value).toFixed(0).toLocaleString()
      return prefix + "" + parseFloat(value).toLocaleString();
    },

    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_low(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    openGoogleMap(item) {
      const urlSuffix = `${item.lat},${item.lon}&z=15`;
      window.open("https://maps.google.com/maps?q=" + urlSuffix, "_blank");
    },
  },
  mounted() {
    // if (!this.currentUser) {
    //   this.$router.push('/login')
    // }else {
    //   this.fetchParent()
    //   this.fetchFInfoPasar()
    // }

    this.fetchParent();
    this.fetchFInfoPasar();
  },
};
</script>

<style scoped>
</style>